import { COMPETITOR_FOLLOWERS_WORDS_EN } from "./competitor-followers-words-en.ts";
import { COMPETITOR_FOLLOWERS_WORDS_ES } from "./competitor-followers-words-es.ts";
import type { UseCasePage } from "./use-case-page.ts";

// One entry per use-case page (ADR-034 point 3, D1170). A page also needs its literal screen entry
// in `use-cases.web.ts` and its address in the use-cases URL list; a test fails when one is missing.
export const USE_CASE_PAGES: readonly UseCasePage[] = [
  {
    path: "/use-cases/competitor-followers",
    slug: "competitor-followers",
    words: { en: COMPETITOR_FOLLOWERS_WORDS_EN, es: COMPETITOR_FOLLOWERS_WORDS_ES },
    related: ["/compare/instagram-email-extractors", "/pricing"],
  },
];

/** The page at an English address; the screens and the data are held together by a test. */
export function pageOfUseCase(path: string): UseCasePage | undefined {
  return USE_CASE_PAGES.find((page) => page.path === path);
}
